import React, { ReactNode } from 'react';

export const escapedNewLineToLineBreakTag = (string: string): ReactNode =>
  // eslint-disable-next-line react/no-array-index-key
  string.split('\n').map((item, index) => (index === 0 ? item : [<br key={index} />, item]));
